'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Select: ()=>Select
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const select_namespaceObject = require("@base-ui-components/react/select");
const external_react_namespaceObject = require("react");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
const external_Select_variants_cjs_namespaceObject = require("./Select.variants.cjs");
function Select({ label, isLabelHidden, helperText, errorText, errorTooltipText, isError, iconLeft, className, menuItems, placeholder, isInset, size, value: controlledValue, initialValue, isDisabled, menuWidth, isAutoWidth = false, selectMinWidth, selectPadding, onChange, ...restProps }) {
    const isControlled = void 0 !== controlledValue;
    const validatedInitialValue = (0, external_react_namespaceObject.useMemo)(()=>{
        if (!initialValue || !menuItems) return '';
        return menuItems.some((item)=>item.value === initialValue) ? initialValue : '';
    }, [
        initialValue,
        menuItems
    ]);
    const [internalValue, setInternalValue] = (0, external_react_namespaceObject.useState)(validatedInitialValue);
    const value = isControlled ? controlledValue : internalValue;
    const [isErrorNew, setIsErrorNew] = (0, external_react_namespaceObject.useState)(isError);
    const [menuOpen, setMenuOpen] = (0, external_react_namespaceObject.useState)(false);
    const [selectWidth, setSelectWidth] = (0, external_react_namespaceObject.useState)(void 0);
    const triggerRef = (0, external_react_namespaceObject.useRef)(null);
    let displayedValue = menuItems?.find((val)=>val.value === value)?.label ?? placeholder;
    if (isInset && !displayedValue) displayedValue = label;
    const calculateWidth = (0, external_react_namespaceObject.useCallback)(()=>{
        if (!isAutoWidth || !triggerRef.current || void 0 === selectMinWidth || void 0 === selectPadding) return;
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) return;
        const computedStyle = window.getComputedStyle(triggerRef.current);
        context.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
        const textWidth = displayedValue ? context.measureText(displayedValue).width : 0;
        const calculatedWidth = Math.max(textWidth + selectPadding, selectMinWidth);
        setSelectWidth(calculatedWidth);
    }, [
        displayedValue,
        isAutoWidth,
        selectMinWidth,
        selectPadding
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        calculateWidth();
    }, [
        calculateWidth,
        displayedValue
    ]);
    const handleOnValueChange = (0, external_react_namespaceObject.useCallback)((newValue, event)=>{
        event?.stopPropagation();
        if (isErrorNew) setIsErrorNew(false);
        const stringValue = 'string' != typeof newValue ? '' : newValue;
        if (!isControlled) setInternalValue(stringValue);
        onChange?.(stringValue);
    }, [
        isErrorNew,
        isControlled,
        onChange
    ]);
    const handleOnOpenChange = (0, external_react_namespaceObject.useCallback)((open, event)=>{
        event?.stopPropagation();
        setMenuOpen(open);
    }, []);
    const styles = (0, external_Select_variants_cjs_namespaceObject.selectVariants)({
        hasIconLeft: !!iconLeft,
        isInset,
        hasValue: Boolean(value),
        hasPlaceholder: Boolean(placeholder),
        size,
        isError: isErrorNew,
        isDisabled,
        isLabelHidden,
        menuOpen,
        isAutoWidth
    });
    const widthClass = isAutoWidth && selectWidth ? `w-[${selectWidth}px]` : '';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Root, {
        value: value,
        onValueChange: handleOnValueChange,
        disabled: isDisabled,
        onOpenChange: handleOnOpenChange,
        ...restProps,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: (0, cn_cjs_namespaceObject.cn)(styles.root(), className),
            children: [
                label && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: styles.label(),
                    children: label
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(select_namespaceObject.Select.Trigger, {
                    ref: triggerRef,
                    className: (0, cn_cjs_namespaceObject.cn)(styles.inputWrapper(), widthClass),
                    children: [
                        iconLeft ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: styles.iconLeft(),
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                iconName: iconLeft,
                                size: "24"
                            })
                        }) : null,
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Value, {
                            className: styles.input(),
                            children: displayedValue
                        }),
                        isErrorNew && errorTooltipText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                            side: "bottom",
                            align: "center",
                            triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                iconName: 'error',
                                size: "20",
                                className: styles.errorTooltipTrigger()
                            }),
                            color: "error",
                            emphasis: true,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                children: errorTooltipText
                            })
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Icon, {
                            className: styles.iconRight(),
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                iconName: "arrow_drop_down",
                                size: "20"
                            })
                        })
                    ]
                }),
                isErrorNew && errorText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: styles.errorText(),
                    children: errorText
                }) : null,
                !isErrorNew && helperText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: styles.helperText(),
                    children: helperText
                }) : null,
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Portal, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Positioner, {
                        className: styles.popupPositioner(),
                        side: "bottom",
                        sideOffset: 5,
                        alignItemWithTrigger: false,
                        collisionAvoidance: {
                            side: 'shift'
                        },
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(select_namespaceObject.Select.Popup, {
                            className: (0, cn_cjs_namespaceObject.cn)(styles.popupMenu(), menuWidth ? `w-[${menuWidth}]` : 'w-[var(--anchor-width)]'),
                            children: menuItems?.map((item)=>{
                                const itemStyles = (0, external_Select_variants_cjs_namespaceObject.selectVariants)({
                                    itemSelected: item.value === value,
                                    itemDisabled: item?.disabled,
                                    itemSuffixInline: item?.suffixIsInline
                                });
                                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(select_namespaceObject.Select.Item, {
                                    value: item.value,
                                    label: item.label,
                                    className: itemStyles.popupItem(),
                                    disabled: item?.disabled,
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                            className: itemStyles.itemLabelIconSuffixWrapper(),
                                            children: [
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                                    className: itemStyles.itemLabelIconWrapper(),
                                                    children: [
                                                        item.icon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                            className: itemStyles.itemIcon(),
                                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                                                iconName: item.icon,
                                                                size: "24"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                                            className: itemStyles.itemLabelWrapper(),
                                                            children: [
                                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                                    className: itemStyles.itemLabel(),
                                                                    children: item.label
                                                                }),
                                                                item.helperText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                                    className: itemStyles.itemLabelHelper(),
                                                                    children: item.helperText
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                item.suffixText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                    className: itemStyles.itemSuffix(),
                                                    children: item.suffixText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                            className: itemStyles.itemSelectedIconWrapper(),
                                            children: item.value === value && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                                iconName: "check",
                                                size: "20",
                                                className: itemStyles.itemSelectedIcon()
                                            })
                                        })
                                    ]
                                }, item.value);
                            })
                        })
                    })
                })
            ]
        })
    });
}
exports.Select = __webpack_exports__.Select;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Select"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
